var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { flat: "", outlined: "", color: "transparent" } },
    [
      _c(
        "v-card-title",
        [
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "10" } }, [
                _c("h4", [
                  _vm._v(
                    _vm._s(_vm.item.name || `Расписание ${_vm.itemIndex + 1}`)
                  ),
                ]),
              ]),
              !_vm.isOnlyEdit
                ? [
                    _c(
                      "v-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on, attrs }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          _vm._b(
                                            {
                                              attrs: {
                                                icon: "",
                                                loading: _vm.isFormLoading,
                                                disabled: _vm.isMutationLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.$emit(
                                                    "edit",
                                                    _vm.item
                                                  )
                                                },
                                              },
                                            },
                                            "v-btn",
                                            attrs,
                                            false
                                          ),
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              826189918
                            ),
                          },
                          [_c("span", [_vm._v("Редактировать расписание")])]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function ({ on }) {
                                    return [
                                      _c(
                                        "div",
                                        _vm._g(
                                          { staticClass: "d-d-inline-block" },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                icon: "",
                                                loading: _vm.isFormLoading,
                                                disabled: _vm.isMutationLoading,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.deleteScheduleHandler(
                                                    _vm.item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "red" } },
                                                [
                                                  _vm._v(
                                                    "mdi-trash-can-outline"
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1039056844
                            ),
                          },
                          [_c("span", [_vm._v("Удалить расписание")])]
                        ),
                      ],
                      1
                    ),
                  ]
                : [
                    _c(
                      "v-col",
                      { attrs: { cols: "1" } },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on, attrs }) {
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            attrs: {
                                              icon: "",
                                              loading: _vm.isFormLoading,
                                              disabled: _vm.isMutationLoading,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.$emit(
                                                  "edit",
                                                  _vm.item
                                                )
                                              },
                                            },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-eye")])],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [_c("span", [_vm._v("Посмотреть расписание")])]
                        ),
                      ],
                      1
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "v-card-text",
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _vm.item.startDate
                        ? _c("v-icon", { attrs: { icon: "mi-calendar_today" } })
                        : _vm._e(),
                      _vm.item.repeatType !== "NO_REPEAT"
                        ? _c("v-icon", { attrs: { icon: "mi-repeat" } })
                        : _vm._e(),
                      _vm.item.startDate
                        ? _c("p", [
                            _c("span", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.formatDate(
                                      _vm.item.startDate,
                                      "DD.MM.YYYY",
                                      "Europe/Moscow"
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _vm.item.endDate &&
                            _vm.item.repeatType !== "NO_REPEAT"
                              ? _c("span", [
                                  _vm._v(
                                    " - " +
                                      _vm._s(
                                        _vm.formatDate(
                                          _vm.item.endDate,
                                          "DD.MM.YYYY"
                                        )
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.chosenWeekDays.length
                ? _c(
                    "v-row",
                    { staticClass: "short-event-details__item" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("p", { staticClass: "is-border-box" }, [
                          _vm._v(" " + _vm._s(_vm.chosenWeekDays) + " "),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.scheduleTimesRanger
                ? _c(
                    "v-row",
                    { staticClass: "short-event-details__item" },
                    [
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _vm._v(" " + _vm._s(_vm.scheduleTimesRanger) + " "),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }